import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{ mode: string }>()
  .create(({ theme, mode }) => ({
    dialogContainer: {
      backgroundColor: theme.vars.palette.transparent.a25,
      '& .MuiDialog-container': {
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: mode === 'Delete' ? '35rem' : '50rem'
        }
      }
    },
    warningColor: {
      color: theme.vars.palette.warning.main
    }
  }));

export default useStyles;
